<template>
  <div class="galleryFullScreenCard">
    <div v-if="element.type === 0"
         :style="`background-image: url(${element.image_url});`"
         class="cardImage" />
    <youtube v-else
             ref="youtube"
             :video-id="videoId" />
  </div>
</template>

<script>
export default {
  props: {
    element: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    videoId: function() {
      return this.$youtube.getIdFromUrl(this.element.video_url)
    }
  },
  mounted() {
    if (this.element.type && this.element.type === 1) {
      this.$root.$on('slideChange', this.stopVideo)
      this.$root.$on(`startVideo${this.element.id}`, this.startVideo)
    }
  },
  destroyed() {
    this.$root.$off('slideChange', this.stopVideo)
  },
  methods: {
    stopVideo: function() {
      if (this.element.type && this.element.type === 1 && this.$refs.youtube) {
        this.$refs.youtube.player.stopVideo()
      }
    },
    startVideo: function() {
      setTimeout(() => {
        if (this.$refs.youtube) {
          this.$refs.youtube.player.playVideo()
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
.galleryFullScreenCard {
  display: contents;
  height: 100px;
  width: 100%;
  .cardImage {
    height: 80vh;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  iframe {
    height: 80vh;
    width: 100%;
  }
}
</style>
